import React from 'react'
import { Card, CardBody, Row, Col, Button } from 'reactstrap'
import Loader from './Loader'

const WorkPermitSection = ({permitData, loading}) => {
    const workPermitData = [
        {
            title: 'Work Permits Is Issued on Site',
            subtitle: 'Authorization management',
            count: permitData?.authorized,
            status: 'Not Approved',
            statusColor: '#ff4757',
            bgColor: '#fff5f5'
        },
        {
            title: 'Work on Site',
            subtitle: 'Authorization management',
            count: permitData?.unAuthorized,
            status: 'Un-Approved',
            statusColor: '#ff4757',
            bgColor: '#fff5f5'
        }
    ]

    return (
        <div className="work-permit-section">
            {/* Header */}
            <div className="section-header mb-3">
                <h5  style={{color:'#1d67aa'}} className=" mb-1">Work Permit</h5>
                <p className="text-muted mb-0">Authorization management</p>
            </div>

            {/* Cards Row */}
            <Row className="g-3">
                {workPermitData.map((item, index) => (
                    <Col md={6} key={index}>
                        <Card className="h-100 border-0 shadow-sm">
                            <CardBody className="p-4">
                                <div className="mb-3">
                                    <h6 className="mb-1 text-dark font-weight-bold">{item.title}</h6>
                                    <p className="text-muted mb-0 small">{item.subtitle}</p>
                                </div>

                                <div
                                    className="text-center py-4 mb-3 rounded"
                                    style={{ backgroundColor: item.bgColor }}
                                >
                                    <h2 className="mb-1 font-weight-bold" style={{ color: item.statusColor }}>
                                        {loading ? <Loader size="md" /> : item.count}
                                    </h2>
                                    <p className="mb-0 small" style={{ color: item.statusColor }}>
                                        {item.status}
                                    </p>
                                </div>

                                <Button
                                    color="primary"
                                    className="w-100 d-flex align-items-center justify-content-center"
                                    style={{ backgroundColor: '#5dade2', borderColor: '#5dade2' }}
                                >
                                    <i className="fa fa-eye me-2"></i>
                                    View Details
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    )
}

export default WorkPermitSection